import type { MessagingGetChatRooms200PageAllOfThreeContentItem } from './messagingGetChatRooms200PageAllOfThreeContentItem';

export type MessagingGetChatRooms200PageAllOfThree = {
  /** 채팅방 목록 */
  content?: MessagingGetChatRooms200PageAllOfThreeContentItem[];
};
